module.exports = __webpack_public_path__ + "img/jr54.9cc75dbc.jpg";